import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ShopifyCollection, ShopifyProduct } from '../../types/shopify';
import ShopifyService from '../../services/shopify';
import ProductGrid from '../../components/ProductGrid/ProductGrid';
import './CollectionPage.scss';

const CollectionPage: React.FC = () => {
  const { handle } = useParams<{ handle: string }>();
  const [collection, setCollection] = useState<ShopifyCollection | null>(null);
  const [products, setProducts] = useState<ShopifyProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const formatTitle = (title: string): string => {
    return title
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  useEffect(() => {
    const loadCollection = async () => {
      if (!handle) return;

      try {
        setLoading(true);
        setError(null);

        const collectionData = await ShopifyService.getCollection(handle);
        
        if (collectionData) {
          setCollection(collectionData);
          setProducts(collectionData.products);
        } else {
          const allProducts = await ShopifyService.getProducts(50);
          let filteredProducts = allProducts;
          
          if (handle === 'archive') {
            filteredProducts = allProducts.filter(product => 
              product.tags.includes('archive') || product.tags.includes('vintage')
            );
          }

          setProducts(filteredProducts);
          setCollection({
            id: handle,
            title: formatTitle(handle),
            handle: handle,
            description: '',
            products: filteredProducts
          });
        }
      } catch (err) {
        console.error('Failed to load collection:', err);
        setError('Failed to load collection');
      } finally {
        setLoading(false);
      }
    };

    loadCollection();
  }, [handle]);

  if (error) {
    return (
      <div className="collection-page">
        <div className="collection-page__error">
          <p>Collection not found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="collection-page">
      <header className="collection-page__header">
        <div className="collection-page__breadcrumb">
          <Link to="/" className="collection-page__breadcrumb-link">Shop</Link>
          <span className="collection-page__breadcrumb-separator">&gt;</span>
        </div>
        {collection && (
          <h1 className="collection-page__title">{collection.title}</h1>
        )}
      </header>

      <ProductGrid 
        products={products}
        loading={loading}
        showFilters={false}
      />
    </div>
  );
};

export default CollectionPage;
